import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconAddLocation, LazyIconAlertCircle, LazyIconAlert, LazyIconArrowAttribute, LazyIconArrowDown, LazyIconArrowDropdown, LazyIconArrowExploreAll, LazyIconArrowForward, LazyIconArrowLeft, LazyIconArrowRight, LazyIconArrowU, LazyIconArrowUp2, LazyIconArrowUpBold, LazyIconArrowUp, LazyIconBadge, LazyIconBed, LazyIconBorderedArrow, LazyIconBoxes, LazyIconC, LazyIconCalendarOutline, LazyIconCalendar, LazyIconCalendar2Thin, LazyIconCalendar2, LazyIconCall, LazyIconCallQuestion, LazyIconCar, LazyIconCart, LazyIconCatalogPin, LazyIconChat, LazyIconCheck2, LazyIconCheckCircle, LazyIconCheckMini, LazyIconCheck, LazyIconCheckBorder, LazyIconChevron2, LazyIconChevronBlack, LazyIconChevronDown2, LazyIconChevronDown, LazyIconChevronMini, LazyIconChevron, LazyIconCircle, LazyIconCityPinColored, LazyIconCityPin, LazyIconClose2, LazyIconCloseBold, LazyIconCloseCircleOutline, LazyIconCloseCircle, LazyIconClose, LazyIconCompass, LazyIconContact, LazyIconCruise, LazyIconCustomerSupport, LazyIconDateRange, LazyIconDesert, LazyIconDollarSignCircle, LazyIconDollar, LazyIconDoubleQuotation, LazyIconDropOff, LazyIconDuration, LazyIconEdit2, LazyIconEmailClosed, LazyIconEmail, LazyIconEmptyCart, LazyIconEyeHide, LazyIconEyeShow, LazyIconFacebook, LazyIconFaqArrow, LazyIconFilterList, LazyIconFilter, LazyIconGallery, LazyIconGetyourguide, LazyIconGlow, LazyIconGoogle, LazyIconGuarantee, LazyIconGuide, LazyIconHamburger, LazyIconHeadphones, LazyIconHelpCenter, LazyIconHotel, LazyIconHouse, LazyIconHouses, LazyIconI, LazyIconInfoBold, LazyIconInfo, LazyIconInstagram, LazyIconInvoice, LazyIconJetski, LazyIconLandscape, LazyIconLinkedin, LazyIconLiveChat, LazyIconLocationHero, LazyIconLocationUnderline, LazyIconLocation, LazyIconLocationOutline, LazyIconLock, LazyIconMail, LazyIconMapPin, LazyIconMap, LazyIconMarker, LazyIconMaximize2, LazyIconMinus, LazyIconMosque, LazyIconNavigation, LazyIconNoData, LazyIconNoSound, LazyIconOotlah, LazyIconOperation, LazyIconOrder, LazyIconPackages, LazyIconPassengers, LazyIconPeopleGroup, LazyIconPersonOutline, LazyIconPerson, LazyIconPhoneInCall, LazyIconPickup, LazyIconPlane, LazyIconPlayCircle, LazyIconPlayFill, LazyIconPlay, LazyIconPlusCircle, LazyIconPlus, LazyIconPolicy, LazyIconPriceTag, LazyIconPriceTier, LazyIconPromoCheck, LazyIconPromoChevronRight, LazyIconPromoClose, LazyIconPromoCopy, LazyIconPromoTicket, LazyIconPyramids, LazyIconQuote, LazyIconRestart, LazyIconReview, LazyIconRing, LazyIconSearchBold, LazyIconSearchIcon, LazyIconSearchLongHandle, LazyIconSearch, LazyIconShare, LazyIconShieldCheck, LazyIconShield, LazyIconShiny, LazyIconSightseeing, LazyIconSnapchat, LazyIconSparkles, LazyIconStar1, LazyIconStar2, LazyIconStar, LazyIconStepperMinus, LazyIconStepperPlus, LazyIconSuccess, LazyIconSupportMail, LazyIconSupportWhatsapp, LazyIconSwap, LazyIconTag, LazyIconTicket, LazyIconTiktok, LazyIconTimer, LazyIconTooltipSimple, LazyIconTooltip, LazyIconTourguide, LazyIconTripadvisorLogo, LazyIconTripadvisor, LazyIconTwitter, LazyIconUserOutline, LazyIconUser, LazyIconUsers, LazyIconViator, LazyIconVisas, LazyIconVoucher, LazyIconWarning, LazyIconWhatsappFill, LazyIconWhatsapp, LazyIconWordVector, LazyIconWorld, LazyIconX, LazyIconYacht, LazyIconYoutube, LazyIconZoomIn } from '#components'
const lazyGlobalComponents = [
  ["IconAddLocation", LazyIconAddLocation],
["IconAlertCircle", LazyIconAlertCircle],
["IconAlert", LazyIconAlert],
["IconArrowAttribute", LazyIconArrowAttribute],
["IconArrowDown", LazyIconArrowDown],
["IconArrowDropdown", LazyIconArrowDropdown],
["IconArrowExploreAll", LazyIconArrowExploreAll],
["IconArrowForward", LazyIconArrowForward],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRight", LazyIconArrowRight],
["IconArrowU", LazyIconArrowU],
["IconArrowUp2", LazyIconArrowUp2],
["IconArrowUpBold", LazyIconArrowUpBold],
["IconArrowUp", LazyIconArrowUp],
["IconBadge", LazyIconBadge],
["IconBed", LazyIconBed],
["IconBorderedArrow", LazyIconBorderedArrow],
["IconBoxes", LazyIconBoxes],
["IconC", LazyIconC],
["IconCalendarOutline", LazyIconCalendarOutline],
["IconCalendar", LazyIconCalendar],
["IconCalendar2Thin", LazyIconCalendar2Thin],
["IconCalendar2", LazyIconCalendar2],
["IconCall", LazyIconCall],
["IconCallQuestion", LazyIconCallQuestion],
["IconCar", LazyIconCar],
["IconCart", LazyIconCart],
["IconCatalogPin", LazyIconCatalogPin],
["IconChat", LazyIconChat],
["IconCheck2", LazyIconCheck2],
["IconCheckCircle", LazyIconCheckCircle],
["IconCheckMini", LazyIconCheckMini],
["IconCheck", LazyIconCheck],
["IconCheckBorder", LazyIconCheckBorder],
["IconChevron2", LazyIconChevron2],
["IconChevronBlack", LazyIconChevronBlack],
["IconChevronDown2", LazyIconChevronDown2],
["IconChevronDown", LazyIconChevronDown],
["IconChevronMini", LazyIconChevronMini],
["IconChevron", LazyIconChevron],
["IconCircle", LazyIconCircle],
["IconCityPinColored", LazyIconCityPinColored],
["IconCityPin", LazyIconCityPin],
["IconClose2", LazyIconClose2],
["IconCloseBold", LazyIconCloseBold],
["IconCloseCircleOutline", LazyIconCloseCircleOutline],
["IconCloseCircle", LazyIconCloseCircle],
["IconClose", LazyIconClose],
["IconCompass", LazyIconCompass],
["IconContact", LazyIconContact],
["IconCruise", LazyIconCruise],
["IconCustomerSupport", LazyIconCustomerSupport],
["IconDateRange", LazyIconDateRange],
["IconDesert", LazyIconDesert],
["IconDollarSignCircle", LazyIconDollarSignCircle],
["IconDollar", LazyIconDollar],
["IconDoubleQuotation", LazyIconDoubleQuotation],
["IconDropOff", LazyIconDropOff],
["IconDuration", LazyIconDuration],
["IconEdit2", LazyIconEdit2],
["IconEmailClosed", LazyIconEmailClosed],
["IconEmail", LazyIconEmail],
["IconEmptyCart", LazyIconEmptyCart],
["IconEyeHide", LazyIconEyeHide],
["IconEyeShow", LazyIconEyeShow],
["IconFacebook", LazyIconFacebook],
["IconFaqArrow", LazyIconFaqArrow],
["IconFilterList", LazyIconFilterList],
["IconFilter", LazyIconFilter],
["IconGallery", LazyIconGallery],
["IconGetyourguide", LazyIconGetyourguide],
["IconGlow", LazyIconGlow],
["IconGoogle", LazyIconGoogle],
["IconGuarantee", LazyIconGuarantee],
["IconGuide", LazyIconGuide],
["IconHamburger", LazyIconHamburger],
["IconHeadphones", LazyIconHeadphones],
["IconHelpCenter", LazyIconHelpCenter],
["IconHotel", LazyIconHotel],
["IconHouse", LazyIconHouse],
["IconHouses", LazyIconHouses],
["IconI", LazyIconI],
["IconInfoBold", LazyIconInfoBold],
["IconInfo", LazyIconInfo],
["IconInstagram", LazyIconInstagram],
["IconInvoice", LazyIconInvoice],
["IconJetski", LazyIconJetski],
["IconLandscape", LazyIconLandscape],
["IconLinkedin", LazyIconLinkedin],
["IconLiveChat", LazyIconLiveChat],
["IconLocationHero", LazyIconLocationHero],
["IconLocationUnderline", LazyIconLocationUnderline],
["IconLocation", LazyIconLocation],
["IconLocationOutline", LazyIconLocationOutline],
["IconLock", LazyIconLock],
["IconMail", LazyIconMail],
["IconMapPin", LazyIconMapPin],
["IconMap", LazyIconMap],
["IconMarker", LazyIconMarker],
["IconMaximize2", LazyIconMaximize2],
["IconMinus", LazyIconMinus],
["IconMosque", LazyIconMosque],
["IconNavigation", LazyIconNavigation],
["IconNoData", LazyIconNoData],
["IconNoSound", LazyIconNoSound],
["IconOotlah", LazyIconOotlah],
["IconOperation", LazyIconOperation],
["IconOrder", LazyIconOrder],
["IconPackages", LazyIconPackages],
["IconPassengers", LazyIconPassengers],
["IconPeopleGroup", LazyIconPeopleGroup],
["IconPersonOutline", LazyIconPersonOutline],
["IconPerson", LazyIconPerson],
["IconPhoneInCall", LazyIconPhoneInCall],
["IconPickup", LazyIconPickup],
["IconPlane", LazyIconPlane],
["IconPlayCircle", LazyIconPlayCircle],
["IconPlayFill", LazyIconPlayFill],
["IconPlay", LazyIconPlay],
["IconPlusCircle", LazyIconPlusCircle],
["IconPlus", LazyIconPlus],
["IconPolicy", LazyIconPolicy],
["IconPriceTag", LazyIconPriceTag],
["IconPriceTier", LazyIconPriceTier],
["IconPromoCheck", LazyIconPromoCheck],
["IconPromoChevronRight", LazyIconPromoChevronRight],
["IconPromoClose", LazyIconPromoClose],
["IconPromoCopy", LazyIconPromoCopy],
["IconPromoTicket", LazyIconPromoTicket],
["IconPyramids", LazyIconPyramids],
["IconQuote", LazyIconQuote],
["IconRestart", LazyIconRestart],
["IconReview", LazyIconReview],
["IconRing", LazyIconRing],
["IconSearchBold", LazyIconSearchBold],
["IconSearchIcon", LazyIconSearchIcon],
["IconSearchLongHandle", LazyIconSearchLongHandle],
["IconSearch", LazyIconSearch],
["IconShare", LazyIconShare],
["IconShieldCheck", LazyIconShieldCheck],
["IconShield", LazyIconShield],
["IconShiny", LazyIconShiny],
["IconSightseeing", LazyIconSightseeing],
["IconSnapchat", LazyIconSnapchat],
["IconSparkles", LazyIconSparkles],
["IconStar1", LazyIconStar1],
["IconStar2", LazyIconStar2],
["IconStar", LazyIconStar],
["IconStepperMinus", LazyIconStepperMinus],
["IconStepperPlus", LazyIconStepperPlus],
["IconSuccess", LazyIconSuccess],
["IconSupportMail", LazyIconSupportMail],
["IconSupportWhatsapp", LazyIconSupportWhatsapp],
["IconSwap", LazyIconSwap],
["IconTag", LazyIconTag],
["IconTicket", LazyIconTicket],
["IconTiktok", LazyIconTiktok],
["IconTimer", LazyIconTimer],
["IconTooltipSimple", LazyIconTooltipSimple],
["IconTooltip", LazyIconTooltip],
["IconTourguide", LazyIconTourguide],
["IconTripadvisorLogo", LazyIconTripadvisorLogo],
["IconTripadvisor", LazyIconTripadvisor],
["IconTwitter", LazyIconTwitter],
["IconUserOutline", LazyIconUserOutline],
["IconUser", LazyIconUser],
["IconUsers", LazyIconUsers],
["IconViator", LazyIconViator],
["IconVisas", LazyIconVisas],
["IconVoucher", LazyIconVoucher],
["IconWarning", LazyIconWarning],
["IconWhatsappFill", LazyIconWhatsappFill],
["IconWhatsapp", LazyIconWhatsapp],
["IconWordVector", LazyIconWordVector],
["IconWorld", LazyIconWorld],
["IconX", LazyIconX],
["IconYacht", LazyIconYacht],
["IconYoutube", LazyIconYoutube],
["IconZoomIn", LazyIconZoomIn],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
